import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery } from '@noths/polaris-client-styles';
import { createGlobalStyle, css } from 'styled-components';

import { nothsTheme } from 'src/styles/noths.theme';

const { fonts } = theme;
const { color: nothsColor, font: nothsFont } = nothsTheme;

export const Wrapper = css`
  box-sizing: border-box;
  background: ${nothsColor.background};
  padding: 10px 0 0;
  text-align: center;
  border-radius: 3px;
  min-height: 60px;

  ${mediaQuery(
    {
      min: minBreakpoints.L,
    },
    css`
      padding: 10px 10px 10px 5px;
    `,
  )}
`;

export const SlideWrapper = css`
  outline: none;
`;

export const Slide = css`
  display: flex;
  align-content: space-around;
  justify-content: center;
  padding: 0 10px;

  ${mediaQuery(
    {
      min: minBreakpoints.L,
    },
    css`
      justify-content: space-between;
    `,
  )}
`;

export const TextBlock = css`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  text-align: left;
  padding: 0;
`;

export const Title = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-size: ${nothsFont.size.XS};
  line-height: 1;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.3px;
  text-align: left;
  color: ${nothsColor.primaryDark};
  margin-bottom: 0;
  margin-top: 0;
  -webkit-font-smoothing: antialiased;
`;

export const Copy = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-size: ${nothsFont.size.XXS};
  line-height: 1;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: ${nothsColor.primary};
  text-align: left;
  margin: 4px 0 0;
  -webkit-font-smoothing: antialiased;
`;

export const IconWrapper = css`
  width: 41px;
  margin-right: 10px;
`;

export const ResponsiveView = css`
  display: flex;
  align-content: space-around;
  justify-content: space-between;
  padding: 0 12px;

  &[data-device='desktop'] {
    visibility: visible;
    ${mediaQuery(
      {
        max: maxBreakpoints.S,
      },
      css`
        display: none;
        visibility: hidden;
      `,
    )}
  }

  &[data-device='mobile'] {
    visibility: visible;
    display: block;
    ${mediaQuery(
      {
        min: minBreakpoints.M,
      },
      css`
        display: none;
        visibility: hidden;
      `,
    )}
  }
`;

export const SlickStyles = createGlobalStyle`
  .slick-prev,
  .slick-next {
    font-size: 0;
    line-height: 0;
    position: absolute;
    top: 50%;
    display: block;
    width: 20px;
    height: 20px;
    padding: 0;
    transform: translate(0, -50%);
    cursor: pointer;
    color: transparent;
    border: none;
    outline: none;
    background: transparent;
  }
  .slick-prev:hover,
  .slick-prev:focus,
  .slick-next:hover,
  .slick-next:focus {
    color: transparent;
    outline: none;
    background: transparent;
  }
  .slick-prev:hover:before,
  .slick-prev:focus:before,
  .slick-next:hover:before,
  .slick-next:focus:before {
    opacity: 1;
  }
  .slick-prev.slick-disabled:before,
  .slick-next.slick-disabled:before {
    opacity: 0.25;
  }

  .slick-prev:before,
  .slick-next:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;

    opacity: 0.75;
    color: white;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-prev {
    left: -25px;
  }
  [dir='rtl'] .slick-prev {
    right: -25px;
    left: auto;
  }
  .slick-prev:before {
    content: '←';
  }
  [dir='rtl'] .slick-prev:before {
    content: '→';
  }

  .slick-next {
    right: -25px;
  }
  [dir='rtl'] .slick-next {
    right: auto;
    left: -25px;
  }
  .slick-next:before {
    content: '→';
  }
  [dir='rtl'] .slick-next:before {
    content: '←';
  }

  /* Dots */
  .slick-dotted.slick-slider {
    margin-bottom: 30px;
  }

  .slick-dots {
    position: absolute;
    bottom: -25px;

    display: block;

    width: 100%;
    padding: 0;
    margin: 0;

    list-style: none;

    text-align: center;
  }
  .slick-dots li {
    position: relative;

    display: inline-block;

    width: 20px;
    height: 20px;
    margin: 0 5px;
    padding: 0;

    cursor: pointer;
  }
  .slick-dots li button {
    font-size: 0;
    line-height: 0;

    display: block;

    width: 20px;
    height: 20px;
    padding: 5px;

    cursor: pointer;

    color: transparent;
    border: 0;
    outline: none;
    background: transparent;
  }
  .slick-dots li button:hover,
  .slick-dots li button:focus {
    outline: none;
  }
  .slick-dots li button:hover:before,
  .slick-dots li button:focus:before {
    opacity: 1;
  }
  .slick-dots li button:before {
    font-family: 'slick';
    font-size: 6px;
    line-height: 20px;

    position: absolute;
    top: 0;
    left: 0;

    width: 20px;
    height: 20px;

    content: '•';
    text-align: center;

    opacity: 0.25;
    color: black;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .slick-dots li.slick-active button:before {
    opacity: 0.75;
    color: black;
  }

  .slick-slider {
    position: relative;
    display: block;
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }

  .slick-list {
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }

  .slick-list:focus {
    outline: none;
  }

  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .slick-track:before,
  .slick-track:after {
    display: table;
    content: '';
  }

  .slick-track:after {
    clear: both;
  }

  .slick-loading .slick-track {
    visibility: hidden;
  }

  .slick-slide {
    display: none;
    float: left;
    height: 100%;
    min-height: 1px;
  }

  [dir='rtl'] .slick-slide {
    float: right;
  }

  .slick-slide.slick-loading img {
    display: none;
  }

  .slick-slide.dragging img {
    pointer-events: none;
  }

  .slick-initialized .slick-slide {
    display: block;
    height: auto;
  }

  .slick-loading .slick-slide {
    visibility: hidden;
  }

  .slick-vertical .slick-slide {
    display: block;
    height: auto;
    border: 1px solid transparent;
  }

  .slick-arrow.slick-next::before,
  .slick-arrow.slick-prev::before {
    display: none;
    visibility: hidden;
    width: 0px;
    height: 0px;
    position: absolute;
  }
`;
